/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { Button } from '@geist-ui/react'
import ErrorPage from './Error'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // You can use your own error logging service here
    this.setState({ errorInfo })
    // Log as error so stack traces are easy to find in the console
    // eslint-disable-next-line no-console
    console.error('Customer portal error boundary caught', {
      error,
      errorInfo,
    })
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      const debug =
        typeof window !== 'undefined' &&
        window?.localStorage?.getItem('WP_DEBUG_ERRORS') === 'true'

      // You can render any custom fallback UI
      return (
        <div className="flex flex-col place-items-center gap-4 h-screen text-primary">
          <ErrorPage
            logo
            title="Unknown error has occurred"
            subheading="Refresh page to try again."
            description="If the error persists, contact support for more help."
            action={
              <Button
                type="success"
                onClick={() => {
                  this.setState({ hasError: false })
                  window && window.location.reload()
                }}
              >
                Try again?
              </Button>
            }
          />
          {debug && (
            <pre
              style={{
                marginTop: '1rem',
                maxWidth: '960px',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                padding: '12px',
                background: '#fafafa',
                border: '1px solid #eee',
                borderRadius: '6px',
              }}
            >
              {this.state.error?.stack || this.state.error?.toString()}
              {'\n\n'}
              {JSON.stringify(this.state.errorInfo, null, 2)}
            </pre>
          )}
        </div>
      )
    }

    // Return children components in case of no error

    return this.props.children
  }
}

export default ErrorBoundary
